import { render, staticRenderFns } from "./ModalReserveMaterial.vue?vue&type=template&id=164014a8&"
import script from "./ModalReserveMaterial.vue?vue&type=script&lang=js&"
export * from "./ModalReserveMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports